import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TennisOneLocalStore } from '../_interfaces';
import { formatDistance, isBefore } from 'date-fns';
import { enUS, fr, es, de, nl } from 'date-fns/locale';

@Injectable({ providedIn: 'root' })
export class SsrLocalstoreService {
    private isBrowser: boolean;

    constructor(@Inject(PLATFORM_ID) private platformId: object) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    get isClientSide(): boolean {
        return this.isBrowser;
    }

    setItem(key: string, value: string): void {
        if (this.isBrowser) {
            localStorage.setItem(key, value);
        }
    }

    getItem(key: string): string | null {
        if (this.isBrowser) {
            return localStorage.getItem(key);
        }
        return null;
    }

    removeItem(key: string): void {
        if (this.isBrowser) {
            localStorage.removeItem(key);
        }
    }

    clear(): void {
        if (this.isBrowser) {
            localStorage.clear();
        }
    }

    isLoggedIn(): Boolean {
        if (this.isBrowser) {
            if (!localStorage.getItem('tennisOne')) {
                return false;
            }
            const store: TennisOneLocalStore = JSON.parse(this.getItem('tennisOne') as string);

            const dateCheck = isBefore(new Date(), new Date(store.user.ttl));

            return store.user && store.user.token && dateCheck ? true : false;
        } else {
            return false;
        }
    }

    getJWT(): string {
        const store: TennisOneLocalStore | null = JSON.parse(this.getItem('tennisOne') as string);

        if (store && store.user && store.user.token) {
            return store.user.token;
        }

        return '';
    }

    getFingerprint(): string {
        const store: TennisOneLocalStore = JSON.parse(this.getItem('tennisOne') as string);

        return store.user.fingerprint ? store.user.fingerprint : '';
    }

    getDistanceDate(time: string | Date | undefined, base_time: Date = new Date()) {
        if (!this.isBrowser) {
            return;
        }

        const preferred_language = this.getItem('preferredLanguage') ? (this.getItem('preferredLanguage') as string) : 'en';
        const locale_map = {
            en: enUS,
            fr: fr,
            es: es,
            de: de,
            nl: nl
        };
        if (time) {
            const format_date = new Date(time);
            const distance = formatDistance(format_date, base_time, { locale: locale_map[preferred_language] });
            if (distance?.trim()?.toLowerCase() === '1 day') {
                return 'yesterday';
            }
            return `${distance} ago`;
        }
        return '';
    }
}
